import { Component, ChangeDetectionStrategy, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { ENV } from '@bodyanalytics/app-config';
import { tap } from 'rxjs';
import { RouterUrlsEnum } from '../../enums/router-urls.enum';
import { NgIf } from '@angular/common';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'bodyanalytics-home',
  standalone: true,
  imports: [NgIf], //PricingTableComponent
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export default class HomeComponent {
  constructor(
    @Inject(ENV) private appConfig: any,
    public auth: AuthService,
    private router: Router,
  ) {
    if (this.isAdminPortal()) {
      this.auth.isAuthenticated$.pipe(
        tap((loggedIn: any) => {
          console.log('is user logged in? ', loggedIn);
          if (loggedIn) {
            console.log('send them here:');
            const url = `${RouterUrlsEnum.AUTH_ADMIN_DASHBOARD}`;
            this.router.navigateByUrl(url);
          }
        }),
      );
    }
  }
  public isAdminPortal(): boolean {
    if (this.appConfig.portalName === 'admin') {
      return true;
    }
    return false;
  }
}
